import React, { useState, useEffect, useCallback } from 'react';
import { Storage } from 'aws-amplify';
import { Button } from "@aws-amplify/ui-react";

function FileUploadDownload({ folder }) {
  const [files, setFiles] = useState([]);
  const [fileList, setFileList] = useState([]);

  const fetchFiles = useCallback(async () => {
    try {
      const files = await Storage.list(folder, { pageSize: 1000 });
      const withSignedUrls = await Promise.all(
        files.results.map(async (f) => {
          const signedUrl = await Storage.get(f.key);
          return { ...f, signedUrl };
        })
      );
      setFileList(withSignedUrls);
    } catch (error) {
      console.error('Error fetching files', error);
    }
  }, [folder]);

  useEffect(() => {
    fetchFiles();
  }, [fetchFiles]);

  const uploadFiles = async () => {
    try {
      if (files.length > 0) {
        await Promise.all(
          files.map(async (file) => {
            const fileKey = `${folder}/${file.name}`;
            console.log(fileKey);
            await Storage.put(fileKey, file);
          })
        );
        setFiles([]);
        fetchFiles();
      }
    } catch (error) {
      console.error('Error uploading files', error);
    }
  };

  const deleteFile = async (fileKey) => {
    try {
      await Storage.remove(fileKey);
      fetchFiles();  // Refresh the file list after deletion
    } catch (error) {
      console.error('Error deleting file', error);
    }
  };

  return (
    <div>
      {Array.isArray(fileList) && fileList.map(f => (
        <div>
          <Button onClick={() => deleteFile(f.key)}>Delete</Button>
          <a href={f.signedUrl} download>{f.key.replace(folder + '/', '')}</a>
        </div>
      ))}
      <div>
        <input type="file" multiple onChange={(e) => setFiles(Array.from(e.target.files))} />
        <Button onClick={uploadFiles}>Upload</Button>
      </div>
    </div>
  );
}

export default FileUploadDownload;
